export default {"theme":{"themes":{"light":{"primary":"#169FAE","accent":"#00537F","secondary":"#E3F0F4","info":"#0D47A1","warning":"#ffb300","error":"#B71C1C","success":"#2E7D32"}}},"icons":{"iconfont":"mdi"},"customProperties":true}
